<template>
  <div style="background-color: #fafafa;">
    <ul class="service clearfix">
      <li>
        <h3>专精专供</h3>
        <p>严选工厂&nbsp;&nbsp;&nbsp;&nbsp;直供零售</p>
        <span>专</span>
      </li>
      <li>
        <h3>品类丰富</h3>
        <p>全车配件&nbsp;&nbsp;&nbsp;&nbsp;一站购齐</p>
        <span>全</span>
      </li>
      <li>
        <h3>正品保障</h3>
        <p>品质护航&nbsp;&nbsp;&nbsp;&nbsp;正品保障</p>
        <span>正</span>
      </li>
      <li>
        <h3>售后无忧</h3>
        <p>自营严选&nbsp;&nbsp;&nbsp;&nbsp;平台质保</p>
        <span>保</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.service {
  width: 1190px;
  padding: 20px 0;
  // border-bottom: 1px solid #ccc;
  display: grid;
  grid-template-columns: repeat(4, auto);
  justify-content: space-around;
  margin: 0 auto;
  
  // display: flex;
  // justify-content: space-around;
  > li {
    position: relative;
    // float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    // width: 246px;
    // height: 50px;
    padding-left: 65px;
    // margin-left: 51px;
    line-height: 24px;
    h3 {
      margin-bottom: 2px;
      color: #1a1a1a;
      font-weight: bold;
      font-size: 14px;
      line-height: 24px;
    }
    span {
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      width: 50px;
      height: 50px;
      border: 2px solid #ff4f1a;
      border-radius: 50%;
      color: #ff4f1a;
      font-weight: bold;
      font-size: 24px;
      line-height: 44px;
      text-align: center;
    }
  }
}
</style>
